import { Component, OnDestroy, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { NodeEntry } from '@alfresco/js-api';

import { DocumentVersion } from '../../model/document-version.model';
import { SelectedVersions } from '../../model/selected-versions.model';
import { getAppSelection } from '../../store/selectors/app.custom-selectors';
import { AppStore } from '../../store/states/app.state';

@Component({
  selector: 'wk-compare-and-merge-dialog',
  templateUrl: './compare-and-merge.dialog.html',
  styleUrls: ['./compare-and-merge.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CompareAndMergeDialogComponent implements OnDestroy {
  tabName: string;
  nodeId: string;
  selectedVersions: SelectedVersions;
  targetDoc: DocumentVersion;
  currentDoc: DocumentVersion;
  private selection: NodeEntry;

  private readonly storeSubscription: Subscription;

  constructor(
    private readonly dialogRef: MatDialogRef<CompareAndMergeDialogComponent>,
    private readonly store: Store<AppStore>,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.storeSubscription = this.store
      .select(getAppSelection)
      .pipe(filter(({ file }) => Boolean(file)))
      .subscribe(({ file }) => {
        this.selection = file;
        this.nodeId = this.selection.entry.id;
      });
  }

  ngOnInit() {
    if (this.data) {
      this.tabName = 'versions';
    } else {
      this.tabName = 'documents';
    }
  }

  ngOnDestroy(): void {
    this.storeSubscription.unsubscribe();
  }

  onTabChange(tabName: string): void {
    this.selectedVersions = null;
    this.tabName = tabName;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  onVersionsSelected(versions: SelectedVersions): void {
    this.selectedVersions = versions;
  }

  merge(): void {
    this.navigateToCompareAndMergePage('merge');
  }

  compare(): void {
    this.navigateToCompareAndMergePage('compare');
  }

  private navigateToCompareAndMergePage(mode: string): void {
    this.targetDoc = this.selectedVersions.target;
    this.currentDoc = this.selectedVersions.current;
    this.dialogRef.close();
    this.router.navigate(
      [
        'favorite',
        'libraries',
        this.selection.entry.parentId,
        mode,
        this.selection.entry.id,
      ],
      {
        queryParams: {
          current: JSON.stringify({
            ...this.selectedVersions.current,
            name: this.currentDoc.name
              ? this.currentDoc.name
              : this.selection.entry.name,
          }),
          target: JSON.stringify({
            ...this.selectedVersions.target,
            name: this.targetDoc.name
              ? this.targetDoc.name
              : this.selection.entry.name,
          }),
        },
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
